module.exports = __webpack_public_path__ + "img/img_realtime_hover.a1587a14.svg";